<template>
  <Preloader absolute/>
</template>


<script>
import Preloader from '@/components/game/Preloader';

export default {
  name: 'AppGame_ViewLoading',

  components: {
    Preloader,
  },
};
</script>
